
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/[slug]",
      function () {
        return require("private-next-pages/books/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/[slug]"])
      });
    }
  